import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'

// Types
import { Props } from '@/components/ui/Badge'

// Props
import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'Badge',
  props: {
    status: {}
  },
  setup(__props: any) {

const props = __props

// i18n
const { t } = useI18n()



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["badge", [`badge_${_ctx.status}`]])
  }, _toDisplayString(_ctx.$t(`badge.${_ctx.status}`)), 3))
}
}

})